import { Navigate } from 'react-router-dom';
import { useStore } from '@hooks/useStore';
import { ProtectedRouteProps } from './types';
import { AuthSessionGate } from './AuthSessionGate';

const SavingsProtected = ({ permissions, element }: ProtectedRouteProps) => {
  const { authStore } = useStore();
  const { hasPermission, user } = authStore;

  const canAccessSavings =
    !!user?.canManageSavingsAccounts && hasPermission(permissions);

  return (
    <AuthSessionGate>
      {canAccessSavings ? element ?? null : <Navigate to="/dashboard" replace />}
    </AuthSessionGate>
  );
};

export default SavingsProtected;
